/**
 *  ts representation of Kms_Enum_MediaCollaborationPermissions
 */
export enum KmsEnumMediaCollaborationPermissions {
    CO_PUBLISH = 1,
    CO_EDIT = 2,
    ALL = 3,
    CO_VIEW = 4,
}
